export default __webpack_public_path__ + "static/product-presentation-BY-c3730f8df5bf65b7a0655cb5dcff5dce.png";